import * as React from "react";
import { ClassType } from "../../class-description";

const data: ClassType = {
	typeId: 1281,
	typeName: "Mercury Fast Track",
	prereq: "Mercury Green Rating or previous experience",
	sessionCt: 1,
	sessionLength: 2.5,
	classSize: 16,
	description: (<React.Fragment>
		Intended for sailors with prior experience elsewhere to become familiar with our boats, safety, and facility so they can jump into Intermediate "running".<br />
		<br />
		Our Fast Track class is an orientation and refresher designed to get a variety of experience level sailors up to speed on our Mercury sailboat and at our facility. Returning Beginners, sailors with experience in other boats and programs, and even sailors who want a refresher after their first week of Beginner Sailing may choose to take this as a first or second introduction to CBI's Junior Program. The class is on land, and includes abbreviated orientation, rigging, and shore school demonstrations.
	</React.Fragment>)
}

export default data; 
